import { UserSettingsPage } from '@cbridge-packages/user-settings';
import { IAlertsDashboardStore } from './alertsDashboard.interface';

export const ALERTS_POLLING_INTERVAL = 5000;

/** Profile setting that remembers whether the user paused the live polling (LB-4992). */
export const ALERTS_POLLING_SETTING_KEY = `${UserSettingsPage.DashboardsAlerts}.polling`;

export const alertsDashboardInitialState: IAlertsDashboardStore = {
  filter: {},
};
